import { balance } from './config/balance.ts';

const curve = (base: number, exponent: number, offset = 0) => (level: number) => Math.round(offset + base * Math.pow(level, exponent));

/** XP needed to go from `level` to `level + 1` in any skill. */
export const skillXpToNext = curve(balance.skills.base, balance.skills.exponent);
/** Renown needed to go from player level `level` to `level + 1`. */
export const renownToNext = curve(balance.renown.base, balance.renown.exponent, balance.renown.offset);

export interface Progress {
  level: number;
  /** XP/Renown accumulated into the current level. */
  into: number;
  /** Needed to reach the next level; null at max. */
  toNext: number | null;
}

function progressFor(total: number, maxLevel: number, toNext: (l: number) => number): Progress {
  let level = 1;
  let remaining = Math.max(0, Math.floor(total));
  while (level < maxLevel) {
    const need = toNext(level);
    if (remaining < need) return { level, into: remaining, toNext: need };
    remaining -= need;
    level++;
  }
  return { level: maxLevel, into: 0, toNext: null };
}

export const skillProgress = (totalXp: number) => progressFor(totalXp, balance.skills.maxLevel, skillXpToNext);
export const renownProgress = (totalRenown: number) => progressFor(totalRenown, balance.renown.maxLevel, renownToNext);

/** Total XP required to reach `level` from level 1. */
export function totalXpForSkillLevel(level: number): number {
  let sum = 0;
  for (let l = 1; l < level; l++) sum += skillXpToNext(l);
  return sum;
}
